/**
 * Elevation tokens. Flat platform (ENG-2145): section boxes, cards, and
 * surfaces carry NO drop shadow — separation comes from borders and tonal
 * fills. All elevation stops resolve to none so inline `boxShadow="sm"|"lg"`
 * (and primitives) flatten without per-call-site edits. Focus rings and the
 * sticky table-header hairline remain.
 */
export const shadows = {
	xs: 'none',
	sm: 'none',
	base: 'none',
	md: 'none',
	lg: 'none',
	xl: 'none',
	'2xl': 'none',
	overlay: 'none',
	focus: '0 0 0 3px rgba(0, 113, 227, 0.35)',
	tableHeader: 'inset 0 -1px 0 var(--chakra-colors-border-default)',
} as const;

export default shadows;
